// frontend/src/samkalp-admin/panels/ProjectsPanel.js
//
// Composes the existing, unmodified Studio ProjectTable/ProgramTable
// components — the same project-creation flow (curriculum/CKB/content/
// assessment-bank) any tenant_admin uses today, scoped to this centre
// (or Samkalp itself). Both components are already prop-driven with no
// useParams/Redux coupling, so direct import is the confirmed-safe path.
import React, { useState, useCallback, useEffect } from 'react';
import { Card, Spinner } from 'react-bootstrap';
import ProjectTable from '../../components/TenantAdmin/ProjectTable';
import ProgramTable from '../../components/TenantAdmin/ProgramTable';
import { getTenantPrograms, getTenantProjects } from '../../api/api';

const ProjectsPanel = ({ slug }) => {
    const [programs, setPrograms] = useState([]);
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const [programsRes, projectsRes] = await Promise.all([
                getTenantPrograms(slug),
                getTenantProjects(slug),
            ]);
            setPrograms(programsRes.data || []);
            setProjects(projectsRes.data || []);
        } catch { /* empty */ }
        setLoading(false);
    }, [slug]);

    useEffect(() => { load(); }, [load]);

    if (loading) return <div className="text-center py-5"><Spinner animation="border" /></div>;

    return (
        <>
            <Card className="shadow-sm border-0 mb-4 rounded-4">
                <Card.Header className="bg-white py-3 border-bottom">
                    <h6 className="mb-0 fw-bold text-primary text-uppercase ls-1">Project Registry &amp; SME Assignment</h6>
                </Card.Header>
                <Card.Body className="p-0">
                    <ProjectTable projects={projects} programs={programs} tenantSlug={slug} onRefresh={load} />
                </Card.Body>
            </Card>

            <Card className="shadow-sm border-0 rounded-4">
                <Card.Header className="bg-white py-3 border-bottom">
                    <h6 className="mb-0 fw-bold text-primary text-uppercase ls-1">Academic Programs</h6>
                </Card.Header>
                <Card.Body className="p-0">
                    <ProgramTable programs={programs} tenantSlug={slug} onRefresh={load} />
                </Card.Body>
            </Card>
        </>
    );
};

export default ProjectsPanel;
